export default "__VITE_ASSET__DiZel7M8__"